export function toFixed(number: number, decimals = 2) {
  const x = Math.pow(10, Number(decimals) + 2);
  return (Number(number) + 1 / x).toFixed(decimals);
}
